export const CHAT_WINDOW_WIDTH = 415; // px
export const MINIMIZE_WIDTH = 250;
export const CHAT_WINDOW_CONFIG = [
  {
    minWidth: 2560, // Ultra-wide monitors (2K / 4K)
    maxWindows: 6,
  },
  {
    minWidth: 1920, // Full HD and above
    maxWindows: 5,
  },
  {
    minWidth: 1600, // Large desktop screens
    maxWindows: 4,
  },
  {
    minWidth: 1366, // Typical laptops
    maxWindows: 3,
  },
  {
    minWidth: 1200, // Smaller laptops
    maxWindows: 2,
  },
  {
    minWidth: 1024, // iPad
    maxWindows: 1,
  },
  {
    minWidth: 992, // Tablet landscape or small desktops
    maxWindows: 1,
  },
  {
    minWidth: 768, // Tablet landscape or small desktops
    maxWindows: 1,
  },
  {
    minWidth: 0, // Mobile
    maxWindows: 1,
  },
];